import { css, keyframes as emotionKeyframes } from '@emotion/css'

const keyframes = emotionKeyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }`

const styles = css``

export default { keyframes, styles }
